const routers = [
    {
    // 供求列表
    path: '/supply/list',
    name: 'supply_list',
    component: () => import('./List.vue')
  }, 
  {
    // 供求表单
    path: '/supply/form/:id?/:categoryIds?',
    name: 'supply_form',
    component: () => import('./Form.vue')

  }
]
export default routers